export default __webpack_public_path__ + "9cb2ce3.png";